import { useState } from "react";
import { useApi } from "@/lib/api";
import { DarkHero, FixtureRow, Loader, Empty } from "@/components/Blocks";
import { sportLabel } from "@/lib/utils";
import { useT } from "@/lib/i18n";

const FILTERS = ["all", "football", "basketball", "athletics", "combat", "handball", "more"];

export default function LiveScores() {
  const { t } = useT();
  const [f, setF] = useState("all");
  const { data, isLoading } = useApi("live", "/live-scores", { refetchInterval: 60000 });
  if (isLoading || !data) return <Loader />;
  const byF = (arr) => (f === "all" ? arr : arr.filter((x) => x.sport === f));
  const groups = [["Live Now", byF(data.live), "live"], ["Upcoming", byF(data.upcoming), "upcoming"], ["Recent Results", byF(data.recent), "recent"]];

  return (
    <div data-testid="live-scores-page">
      <DarkHero title="Live Scores" subtitle="All Cameroonian sport. Real time." image="https://images.unsplash.com/photo-1459865264687-595d652de67e?crop=entropy&cs=srgb&fm=jpg&q=70&w=1600" small />
      <div className="container-x py-8">
        <div className="flex gap-2 overflow-x-auto no-scrollbar pb-2" data-testid="live-filters">
          {FILTERS.map((s) => (
            <button key={s} onClick={() => setF(s)} data-testid={`live-filter-${s}`} className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-bold transition-colors ${f === s ? "bg-[#047857] text-white" : "bg-slate-100 text-slate-700 hover:bg-slate-200"}`}>{s === "all" ? t("All") : t(sportLabel(s))}</button>
          ))}
        </div>
        <p className="mt-3 text-xs text-slate-500" data-testid="live-note">{data.note}</p>
        {groups.map(([title, arr, id]) => (
          <div key={id} className="mt-8" data-testid={`live-group-${id}`}>
            <h2 className="mb-3 font-display text-2xl font-extrabold text-slate-900">{t(title)}</h2>
            <div className="space-y-2">{arr.length ? arr.map((x) => <FixtureRow key={x.id} f={x} />) : <Empty text={id === "live" ? "No matches in play right now." : "Nothing to show for this filter."} />}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
